<template>
  <div id="LeaderView" class="leader-view">
    <Header></Header>
    <b-container fluid>
      <b-row>
        <CompetitorLeftNav></CompetitorLeftNav>
        <b-col>
          <b-row>
            <b-col class="pl-sm-5">
              <h4>{{message}}</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pl-sm-5 origination-container">
              <multiselect id="select-origination-select" v-model="origination" :options="originationCountries" :custom-label="customLabel" track-by="id" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pl-sm-5">
              <b-table striped
                :items="callingCorridors"
                :fields="fields"
                :filter="tableFilter"
                @sort-changed="sortingChanged"
                :sort-compare="compareRows"
                :sort-direction="sortDirection"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc">
                <template slot="country" slot-scope="data">
                  <h6>
                    {{data.item.toCountry.value}}
                  </h6>
                </template>
                <template slot="lastProcessed" slot-scope="data">
                  {{data.item.lastProcessed | formatDate}}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import CompetitorLeftNav from '@/components/layout/CompetitorLeftNav'
import Header from '@/components/layout/Header'
import { mapActions, mapGetters } from 'vuex'
import { sortByDate, sort, sortRate } from '@/util/sorting'
export default {
  name: 'Rates',
  components: {
    CompetitorLeftNav,
    Header
  },
  created () {
    this.clearCallingCorridors()
    this.fetchOriginationCountries().then(() => {
      this.fetchPriceLeaderCountries(this.origination.isoAlpha2).then(() => {

      })
    })
  },
  methods: {
    ...mapActions({
      'fetchPriceLeaderCountries': 'competitor/fetchPriceLeaderCountries',
      'clearCallingCorridors': 'competitor/clearCallingCorridors',
      'fetchOriginationCountries': 'competitor/fetchOriginationCountries'
    }),
    compareRows (a, b) {
      if (this.sortBy === 'lastProcessed') {
        return sortByDate(this.sortDesc, a.lastProcessed, b.lastProcessed)
      } else if (this.sortBy === 'country') {
        return sort(this.sortDesc, a.toCountry.value, b.toCountry.value)
      } else if (this.sortBy === 'mobile') {
        return sortRate(this.sortDesc, a.mobile, b.mobile)
      } else if (this.sortBy === 'landline') {
        return sortRate(this.sortDesc, a.landline, b.landline)
      }
    },
    sortingChanged (ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
    },
    customLabel ({ isoAlpha2, currencyCode }) {
      return `${isoAlpha2} – ${currencyCode}`
    }
  },
  watch: {
    origination: {
      handler () {
        this.fetchPriceLeaderCountries(this.origination.isoAlpha2).then(() => {

        })
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      'isLoading': 'loader/isLoading',
      'callingCorridors': 'competitor/callingCorridors',
      'originationCountries': 'competitor/originationCountries'
    }),
    message () {
      return `Price leader to ${this.callingCorridors.length} countries`
    }
  },
  data () {
    return {
      origination: { id: 1, isoAlpha2: 'US', currencyCode: 'USD' },
      sortBy: 'country',
      sortDesc: false,
      sortDirection: 'desc',
      tableFilter: null,
      fields: [
        { key: 'country', label: 'Country', sortable: true },
        { key: 'mobile', label: 'Mobile', sortable: true },
        { key: 'landline', label: 'Landline', sortable: true },
        { key: 'lastProcessed', label: 'Last updated', sortable: true }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
h4{
  margin-top: 30px;
}
.multiselect{
  max-width: 300px;
}
.origination-container{
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/competitor/Leader.vue